module.exports = __webpack_public_path__ + "img/app-tcby-menu-25.7b1a4127.png";